import { ProviderOrderSource } from 'interfaces/stores/Shipping';

/** Resolve selected PO source by id — works with regional names (PO-SG…/PO-TR…/PO-UK…). */
export const findAddressSourceDocumentById = (
  documents: ProviderOrderSource[],
  sourceId: number | null | undefined,
): ProviderOrderSource | undefined => {
  if (sourceId == null) return;

  return documents.find((doc) => doc.sourceId === sourceId);
};
